import React, { useState } from 'react';
import { Button } from 'antd';
import { Comment } from './Comments';
import { DialogIcon } from '@/assets/icons/DialogIcon';
import { useUpdateAttachment } from '@/hooks/useUpdateAttachment';
import { useApplicationContext } from '@/context/v1/Application/context';
import { useUpdateAttachment as useUpdateAttachmentActionPlan } from '@/hooks/v2/useUpdateAttachment';

interface ButtonUpdateCommentsProps {
	attachmentId: string;
	src: string;
	disabled?: boolean;
	description?: string;
	isActionPlanOrigin?: boolean;
}

export function ButtonUpdateComments({
	attachmentId,
	src,
	description = '',
	disabled = false,
	isActionPlanOrigin = false
}: Readonly<ButtonUpdateCommentsProps>) {
	const [visible, setVisible] = useState<boolean>(false);

	const attachment = useUpdateAttachment();
	const actionPlan = useUpdateAttachmentActionPlan();
	const { organization, company } = useApplicationContext();

	async function handleOnConfirm(description: string): Promise<void> {
		let payload = {
			organization_id: organization?.id!,
			company_id: company?.id!,
			description: description,
			action_plan_attachment_id: attachmentId,
			id: attachmentId
		};

		isActionPlanOrigin ? await actionPlan.mutateAsync(payload) : await attachment.mutateAsync(payload);
		handleOnClose();
	}

	function handleOnShowModal(): void {
		setVisible(true);
	}

	function handleOnClose(): void {
		setVisible(false);
	}

	function handleOnClick(): void {
		handleOnShowModal();
	}

	const isLoading = attachment.isLoading || actionPlan.isLoading;

	return (
		<>
			<Comment
				visible={visible}
				previewType="image"
				previewImage={src}
				loading={isLoading}
				description={description}
				onConfirm={handleOnConfirm}
				onCancel={handleOnClose}
			/>
			<Button type="ghost" disabled={disabled} icon={<DialogIcon />} onClick={handleOnClick} />
		</>
	);
}
